/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';
import $ from 'jquery';
/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
    const dropDownEl = $('.js-dropdown');
    const form = new Form();
    const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
    const dropDown = new DropDown(dropDownEl);
    const topMenu = new TopMenu(topMenuEl);
    const productMinitature = new ProductMinitature();
    const productSelect = new ProductSelect();
    dropDown.init();
    form.init();
    topMenu.init();
    productMinitature.init();
    productSelect.init();


    // GENERAL

    // Smooth scroll
    $('a[href^="#"]').on('click', function() {
      var $target = $($(this).attr('href'));

      // Not for these elements
      if(!$target.length
            || $(this).data('toggle')
            || $(this).hasClass('carousel-control')
        ) {
        return true;
      }

      // Animate scroll
      $('html, body').animate( { scrollTop: $target.offset().top }, 750 );
      return false;
    });

    // Bouton Back to top : apparait si scroll > 1000
    $(window).scroll(function() {
        if($(this).scrollTop() > 1000){
            $('.back-to-top').show();
        }else{
            $('.back-to-top').hide();
        }
    });

    // Sliders
    $('.carousel[data-touch="true"]').swipe({
        swipe(event, direction) {
            if (direction === 'left') {
                $(this).carousel('next');
            }
            if (direction === 'right') {
                $(this).carousel('prev');
            }
        },
        allowPageScroll: 'vertical',
    });

    // Slider des marques
    $('.carousel-manufacturers').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<span class="slickArrow slickArrow--prev"></span>',
        nextArrow: '<span class="slickArrow slickArrow--next"></span>',
        responsive: [
            {
                breakpoint: 1024, //below
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768, //below
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 414, //below
                settings: {
                    slidesToShow: 2,
                    arrows: false
                }
            },
        ]
    });
    
    var $carouselBlockSlider = $('.carousel-blockslider').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<span class="slickArrow slickArrow--prev"></span>',
        nextArrow: '<span class="slickArrow slickArrow--next"></span>',
        responsive: [
            {
                breakpoint: 1700, //below
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1500, //below
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1200, //below
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1000, //below
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768, //below
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $carouselBlockSlider.on('beforeChange', (slick, currentSlide) => {
        var $showSlide = $('.carousel-blockslider .slick-slide.slick-active');
        $showSlide.removeClass('opacity');
    }).trigger('beforeChange');

    const sizeDeviceMobile = window.prestashop.responsive.current_width;
    if(sizeDeviceMobile > 1000){
        $carouselBlockSlider.on('afterChange', (slick, currentSlide) => {
            var $showSlide = $('.carousel-blockslider .slick-slide.slick-active');
            var $firstSlide = $($showSlide[0]);
            var $lastSlide = $($showSlide[$showSlide.length -1]);

            $firstSlide.addClass('opacity');
            $lastSlide.addClass('opacity');
        }).trigger('afterChange');
    }

    var $carouselFeaturedProducts = $('.carousel-featured-products').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<span class="slickArrow slickArrow--prev"></span>',
        nextArrow: '<span class="slickArrow slickArrow--next"></span>',
        responsive: [
            {
                breakpoint: 1400, //below
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1200, //below
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1000, //below
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576, //below
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $carouselFeaturedProducts.on('beforeChange', (slick, currentSlide) => {
        var $showSlide = $('.carousel-featured-products .slick-slide.slick-active');
        $showSlide.removeClass('opacity');
    }).trigger('beforeChange');

    if(sizeDeviceMobile > 1000){
        $carouselFeaturedProducts.on('afterChange', (slick, currentSlide) => {
            var $showSlide = $('.carousel-featured-products .slick-slide.slick-active');
            var $lastSlide = $($showSlide[$showSlide.length -1]);

            $lastSlide.addClass('opacity');
        }).trigger('afterChange');
    }

    
    // HEADER

    // Fonction à recharger au scroll et au redimensionnement de la fenêtre
    $(window).on('scroll', function(){
      stickyHeader();
    });

    // Sticky header
    var headerHeight = $('#header').outerHeight()
    function stickyHeader(){
      if(($(window).scrollTop() > 30) && ($(window).innerWidth() > 1150)){
        $('#wrapper').css('margin-top', headerHeight);
        $('#header').addClass('sticky-header');
      }else{
        $('#header').removeClass('sticky-header');
        $('#wrapper').css('margin-top', 0);
      }
    };
    stickyHeader();

    $('.prmn_columns_li').on('click', function(){
      $(this).find('.ets_prmn_categories').toggleClass('active');
    });

    // En vue mobile modifier l'emplacement du champ rechercher
    if($(document).innerWidth() < 768){
      $('#search_widget').appendTo('#_mobile_search');
      $('#header #search_widget form').on('click', function(){
        $('#header #search_widget form input[type=text]').css('width','80%');
        $('#header #search_widget form input[type=text]').css('border','2px solid #818181');
      })
    }


    // PAGE D'ACCUEIL

    // Carousel Header Page d'accueil
    $('.carousel-header').slick({
        autoplay: true,
        fade: true,
        asNavFor: '.carousel-header-nav'
    });

    let carouselHeaderNavItem = $('.carousel-header-nav-item').length;

    $('.carousel-header-nav').slick({
        slidesToShow: carouselHeaderNavItem,
        asNavFor: '.carousel-header',
        focusOnSelect: true
    });

    // Afficher bouton lire la suite en mobile
    if($(document).innerWidth() < 768){
      $('.lire-la-suite').on('click', function(){
        $(this).siblings($('.yns.featured-products .p.desc')).css({ "max-height": "unset", "mask-image": "unset", "-webkit-mask-image": "unset" });
        $(this).hide();
      });
    }else{
      $('.lire-la-suite').hide();
    }


    // PAGE LISTING

    // Afficher vue Grille
    function showGrid(){
        setCookie('show_list', 0, '1');
        $('#js-product-list .product_miniature_item').removeClass('show_list');
        $('.img-vue-listing').removeClass('active');
        $('span.show_grid').addClass('active');
    }
    // Afficher vue Liste
    function showList(){
        setCookie('show_list', 1, '1');
        $('#js-product-list .product_miniature_item').addClass('show_list');
        $('.img-vue-listing').removeClass('active');
        $('span.show_list').addClass('active');
    }

    $('span.show_grid').click(function () {
        showGrid();
    });
    $('span.show_list').click(function () {
        showList();
    });

    // Afficher les vues au changement de page
    prestashop.on('updateProductList', function (event) {
        $('span.show_grid').click(function () {
            showGrid();
        });
        $('span.show_list').click(function () {
            showList();
        });
    });

    getCookie('show_list');
    checkCookie();

    // Forcer la vue grid pour les petits écrans
    if($(document).innerWidth() < 992){
        $('#js-product-list .product_miniature_item').removeClass('show_list');
        // console.log($(document).innerWidth());
    }


    // PAGE MARQUES 
    // Liens alphabétiques
    for(var i = 65; i <= 90; i++){
        $('#alphabet-list').append('<li><a href="#marque-' + String.fromCharCode(i) + '" class="letter">' + String.fromCharCode(i) + '</a></li>');
    }


    // PAGE PRODUIT

    // Afficher les boutons de partage sur les réseaux sociaux
    $('#product .social-sharing').on('click', function(){
        $('#product .social-sharing ul').show();
    });

    // Afficher la description du produit en entier si celle si est courte
    if($('#product .description-produit .product-description').height() < 400){
        $('#product .description-produit .product-description').css('-webkit-mask-image','none');
        $('#product .description-produit .en-savoir-plus').hide();
    }
    $('#product .description-produit .en-savoir-plus').on('click', function(){
        $('#product .description-produit .product-description').css('-webkit-mask-image','none');
        $('#product .description-produit .product-description').css('max-height','unset');
        $(this).hide();
    });

    // Masquer le bandeau "indisponible" pour les produits disponibles uniquement en magasin
    $('.product-flag:contains("Indisponible")').hide();

});

// Set a Cookie
function setCookie(key, value, expiry){
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
}

// Returns the value of a specified cookie
function getCookie(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// Checks if the cookie 'show_list' is set
function checkCookie(){
    var cookieValue = getCookie('show_list');
    if (cookieValue != ''){
        // console.log("Cookie 'show_list' value : " + cookieValue);
        $(cookieValue == 0 ? 'span.show_grid':  'span.show_list' ).trigger('click');
    }
}



// WEBPACK FOOTER //
// ./js/theme.js